import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  Input,
  VStack,
} from "@chakra-ui/react";

export interface DuplicateModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  nameLabel?: string;
  name: string;
  onNameChange: (name: string) => void;
  onConfirm: () => void | Promise<void>;
  isLoading?: boolean;
  /**
   * Optional extra form fields or options to render below the name input
   * (e.g. "Copy Scenarios" / "Copy Notes" checkboxes for analyst duplication).
   */
  children?: React.ReactNode;
}

const DuplicateModal: React.FC<DuplicateModalProps> = ({
  isOpen,
  onClose,
  title = "Duplicate",
  nameLabel = "Name",
  name,
  onNameChange,
  onConfirm,
  isLoading,
  children,
}) => (
  <Modal isOpen={isOpen} onClose={onClose}>
    <ModalOverlay backdropFilter="blur(4px)" />
    <ModalContent borderRadius="xl" mx={4}>
      <ModalHeader>{title}</ModalHeader>
      <ModalCloseButton />
      <ModalBody pb={6}>
        <VStack spacing={5} align="stretch">
          <FormControl>
            <FormLabel fontSize="sm" fontWeight="600" color="gray.700">
              {nameLabel}
            </FormLabel>
            <Input
              value={name}
              onChange={(e) => onNameChange(e.target.value)}
              placeholder="Enter name"
              size="lg"
              _focus={{
                borderColor: "purple.400",
                boxShadow: "0 0 0 1px var(--chakra-colors-purple-400)",
              }}
            />
          </FormControl>
          {children}
        </VStack>
      </ModalBody>
      <ModalFooter>
        <Button variant="ghost" mr={3} onClick={onClose} isDisabled={isLoading}>
          Cancel
        </Button>
        <Button
          colorScheme="purple"
          onClick={onConfirm}
          isDisabled={!name.trim()}
          isLoading={isLoading}
        >
          Duplicate
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
);

export default DuplicateModal;
